import "../App.css";
import "../styles/login.css";
import { withRouter } from "react-router-dom";
import CurrentUser from "./CurrentUser";
import { useState } from "react";
function Separacion(props) {
  const { history } = props;
  const [user, setUser] = useState(CurrentUser.user);

  const profiles = user?.hmcyaUsers?.profiles;

  const isAbogado =
    profiles?.length === 1 && profiles?.[0]?.description === "ABOGADO";

  // CurrentUser.reloadUser()
  let separarPage = (param) => {
    history.push(param);
  };
  return (
    <div className="App">
      <div id="login">
        <div className="container">
          <br></br>
          <br></br>
          <div className="row justify-content-center align-items-center">
            <div className="col-md-12">
              {!isAbogado && (
                <div
                  className="ajuste col-md-4"
                  style={{ cursor: "pointer" }}
                  onClick={() => separarPage("/Usuarios")}
                >
                  <div className="borderSeparacion">
                    <br></br>
                    <i className="glyphicon glyphicon-book iconSeparacion">
                      <p className="letrasSeparacion">Mantenedores</p>
                    </i>
                  </div>
                </div>
              )}

              <div
                className="ajuste col-md-4"
                style={{ cursor: "pointer" }}
                onClick={() => separarPage("/BusquedaCausas")}
              >
                <div className="borderSeparacion">
                  <br></br>
                  <i className="glyphicon glyphicon-briefcase iconSeparacion">
                    <p className="letrasSeparacion">Procesos de cobranza</p>{" "}
                  </i>
                </div>
              </div>
              {!isAbogado && (
                <div
                  className="ajuste col-md-4"
                  style={{ cursor: "pointer" }}
                  onClick={() => separarPage("/Reporte")}
                >
                  <div className="borderSeparacion">
                    <br></br>
                    <i className="glyphicon glyphicon-tasks iconSeparacion">
                      <p className="letrasSeparacion">Reportes</p>
                    </i>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Separacion);
